<template>
  <div class="Trainee-TS-modal-overlay">
    <div class="Trainee-TS-modal-dialog" @click.stop>
      <div class="Trainee-TS-modal-content">
        <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
        <div class="Trainee-TS-modal-header">
          <h5 class="Trainee-TS-modal-title" style="padding-top: 10px;">Task ID: {{ taskId }}</h5>
        </div>
        <div class="tabs">
          <ul class="nav nav-tabs">
            <li v-for="(revoke, index) in revokes" :key="revoke.revoke_id" class="nav-item">
              <a class="nav-link" :class="{ active: currentTab === index }" @click.prevent="selectTab(index)" href="#">
                Revoke #{{ revoke.revoke_no }}
              </a>
            </li>
          </ul>
          <div class="artificial-fieldset">
            <div class="sign-off">
              <p><b>Sign Off: </b>{{ formatDisplayDate(selectedRevoke.sign_off_date) }}</p>
            </div>
            <div class="question">
              <table class="trainee-info-table">
                <tbody>
                  <tr>
                    <th>Reason given by instructor for Revoking Sign Off</th>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="trainee-answer-section">
              <div ref="editor" class="quill-editor" :class="{ 'read-only': readOnly }" disabled></div>
            </div>
          </div>
          <div class="button-container">
            <button class="ins-close-button" @click="close">Close</button>
            <div class="right">
              <!-- <button class="ins-save-button" @click="save(1)" :disabled="isSubmitted > 1">Save</button> -->
              <!-- <button class="ins-submit-button" @click="submitAnswers" :disabled="isSubmitted > 1">Submit</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

export default {
  name: 'revokeSignOffModal',
  props: {
    logbookentryId: {
      type: [String, Number],
      required: true,
    },
    instructorId: {
      type: [String, Number],
      required: true,
    },
    signOff: {
      type: [String, Number],
      required: true,
    },
    taskId: {
      type: [String, Number],
      required: true,
    },
    logbookId: {
      type: [String, Number],
      required: true,
    },
    revokeReason: String,
  },
  data() {
    return {
      showRevokeModal: true,
      currentTab: 0, // now represents the index of the selected revoke
      quill: null,
      revoked: false,
      revokes: [], // all fetched revokes
    };
  },
  watch: {
    showRevokeModal(newValue) {
      if (newValue && this.quill) {
        // Wait for the next tick to ensure the Quill editor is mounted and visible
        this.$nextTick(() => {
          this.quill.root.innerHTML = this.editableRevoke || '';
        });
      }
    },
    editableRevoke(newVal) {
      if (newVal !== this.quill.root.innerHTML) {
        this.quill.root.innerHTML = newVal;
      }
    },
    currentTab(newVal, oldVal) {
      if (newVal === 'troubleshoot' && oldVal === 'description') {
        this.initializeQuillEditor();
      }
    },
  },
  computed: {
    selectedRevoke() {
      return this.revokes[this.currentTab] || {};
    },
  },
  methods: {
    initializeQuillEditor() {
      if (!this.quill) {
        this.quill = new Quill(this.$refs.editor, {
          theme: 'snow',
          modules: {
            toolbar: [],
          },
        });
        this.quill.getModule('toolbar').container.style.display = 'none'; // This hides the toolbar

        this.quill.on('text-change', () => {
          this.editableRevoke = this.quill.root.innerHTML;
        });

        this.quill.root.innerHTML = this.editableRevoke || '';
        this.adjustEditorHeight();
      }
    },
    formatDisplayDate(dateStr) {
      const date = new Date(dateStr);
      if (isNaN(date.getTime())) return 'Invalid date';

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    },
    getValidSignOffDate() {
      const parsedDate = this.parseCustomDate(this.signOff);
      if (!parsedDate || isNaN(parsedDate.getTime())) {
        console.warn("Invalid signOff date:", this.signOff);
        return this.formatDate(new Date()); // fallback
      }
      return this.formatDate(parsedDate);
    },
    parseCustomDate(dateStr) {
      // Expected format: "DD/MM/YYYY HH:mm:ss"
      const [datePart, timePart] = dateStr.split(' ');
      const [day, month, year] = datePart.split('/').map(Number);
      const [hours, minutes, seconds] = timePart.split(':').map(Number);
      return new Date(year, month - 1, day, hours, minutes, seconds);
    },
    formatDate(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    loadAnswers() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      axios
        .get(`/api/entries/${this.logbookentryId}/revokes`, { headers })
        .then((response) => {
          this.revokes = response.data.filter(revoke => revoke.is_instructor_signoff === 0);

          if (this.quill) {
            if (this.currentTab === 'new') {
              this.quill.root.innerHTML = ''; // Ensure it's empty for new tab
              this.quill.enable(true);
              this.revoked = false;
            } else if (this.revokes.length > 0) {
              const selectedRevoke = this.revokes[this.currentTab] || this.revokes[0];
              this.quill.root.innerHTML = selectedRevoke.revoke_reasoning || '';
              this.revoked = selectedRevoke.is_revoked === 1;

              if (this.revoked) {
                this.makeEditorReadOnly();
              } else {
                this.quill.enable(true);
              }
            }
          }
        })
        .catch((error) => {
          console.error('Failed to load answers', error);
        });
    },
    adjustEditorHeight() {
      const editorElement = this.$refs.editor.querySelector('.ql-editor');
      const toolbar = this.$refs.editor.querySelector('.ql-toolbar');
      const toolbarButtons = this.$refs.editor.querySelectorAll('.ql-toolbar .ql-formats');

      if (editorElement) {
        editorElement.style.height = '260px';
        editorElement.style.fontFamily = 'monospace';
      }
      if (toolbar) {
        toolbar.style.height = '40px';
        toolbar.style.minHeight = '30px';
      }
      if (toolbarButtons) {
        toolbarButtons.forEach((btnGroup) => {
          btnGroup.style.margin = '0 2px';
        });
      }
    },
    close() {
      this.$emit('close');
    },
    makeEditorReadOnly() {
      if (this.quill) {
        this.quill.enable(false); // This disables editing
        this.quill.getModule('toolbar').container.style.display = 'none'; // This hides the toolbar
      }
      //this.$emit('close');
    },
    selectTab(index) {
      this.currentTab = index;

      if (index === 'new') {
        this.quill.root.innerHTML = '';
        this.revoked = false;
        this.quill.enable(true);
        return;
      }

      const selectedRevoke = this.revokes[index];
      this.quill.root.innerHTML = selectedRevoke.revoke_reasoning || '';
      this.revoked = selectedRevoke.is_revoked === 1;

      if (this.revoked) {
        this.makeEditorReadOnly();
      } else {
        this.quill.enable(true);
      }
    },
  },
  mounted() {
    this.initializeQuillEditor();
    this.loadAnswers();
    console.log('logbookentryid', this.logbookentryId);
  },
}
</script>

<style scoped>
table.trainee-info-table {
  font-family: Arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  margin-top: 10px;
}

.trainee-info-table th,
.trainee-info-table td {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 6px;
  font-size: 14px;
}

.trainee-info-table td {
  font-weight: 100;
}

.trainee-info-table th {
  background-color: #f2f2f2;
}

.Trainee-TS-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  /* Semi-transparent background */
  display: flex;
  justify-content: center;
  z-index: 1000;
}

.Trainee-TS-modal-body h2 {
  list-style-type: none;
  margin-top: 10px;
  padding: 0;
  margin-right: 1%;
  text-align: center;

}

.Trainee-TS-modal-body ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  text-align: left;
  margin-left: 5%;
}

.Trainee-TS-modal-body p.heading {
  list-style-type: none;
  margin-top: 20px;
  text-align: left;
  margin-left: 1%;
}

.assessment-criteria-box {
  border: 1px solid #b1b1b1;
  /* You can adjust the border color and thickness */
  padding: 10px;
  /* Optional: Add padding for better appearance */
  margin: 10px 0;
  /* Optional: Add margin for spacing */
}


.Trainee-TS-modal-content {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 1000px;
  width: 100%;
  margin: auto;
  padding: 0;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.Troubleshoot-modal-dialog {
  display: flex;
  flex-direction: row;
  /* Arrange children (questions and answers) in a row */
}

.Trainee-TS-modal-dialog {
  max-height: 90vh;
  overflow-y: auto;
}

.Troubleshoot-modal-body {
  display: flex;

}

.question-item {
  margin: 10px 0;
  text-align: left;
  font-weight: bold;
}

.Trainee-questions-container>ol>li>ul {
  list-style-type: disc;
  /* Adds a bullet point (dot) */
  padding-left: 40px;
  /* Indent subpoints further than the main list */
}

.Trainee-questions-container ul li {
  margin: 5px 0;
}

.Trainee-questions-container {
  text-align: left;
}

button {
  /* Adjust as needed */
  width: 100px;
  /* Adjust as needed */
  padding: 10px;
  /* Adjust as needed */
  background-color: #f2f2f2;
  /* Style as needed */
  border: none;
  /* Style as needed */
  cursor: pointer;
  /* Style as needed */
  /* Add more styling as needed */
}

.questions-list {
  text-align: left;
}

.Trainee-questions-container h6,
.Trainee-answers-container h6 {
  width: 100%;
  background-color: rgb(216, 216, 216);
  /* Light grey background */
  /* Border for the header */
  text-align: center;

}


.list-group-item {
  background-color: transparent;
  /* Remove default background */
}

.list-group-numbered {
  counter-reset: list-group-counter;
  text-align: left;
}

.list-group-numbered>.list-group-item:before {
  content: counter(list-group-counter) ". ";
  counter-increment: list-group-counter;
}

/* Style for the nested ul */
.Trainee-questions-container ul {
  list-style-type: none;
  /* Removes bullet points */
  padding-left: 20px;
  /* Indent subpoints */
}

.Trainee-answers-container {
  outline: none;
  z-index: 1000;
  width: 60%;
}

.right {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  /* Adjust the gap between buttons */
}

.nav-link {
  cursor: pointer;
}

.artificial-fieldset {
  border: 1px solid #ddd;
  border-top: none;
  padding: 10px;
  position: relative;
}

.artificial-fieldset-legend {
  position: absolute;
  top: -10px;
  left: 10px;
  background-color: #fff;
  padding: 0 10px;
  font-weight: bold;
}


.question {
  text-align: left;
  font-weight: bold;
}

.navigation-buttons {
  margin-top: 5px;
}

.nav-button {
  padding: 5px 15px;
  /* Adjust padding to change button size */
  margin: 0 5px;
  /* Space between buttons */

}


.ql-toolbar {
  height: 40px;
  min-height: 40px;
}


.ql-toolbar .ql-formats {
  margin: 0 2px;
}

.ql-container .ql-editor {
  height: 200px;
  min-height: 200px;
}

h4 {
  font-size: 1.5rem;
  margin-top: 30px;
  margin-bottom: 30px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin: 20px;
}

.ins-save-button {
  background-color: #007bff;
  color: white;
  border: 1px solid #0157b3;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
}

.ins-save-button:hover {
  background-color: #0462c7;
}

.ins-submit-button {
  background-color: brown;
  border: 1px solid rgb(99, 15, 15);
  color: white;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 20px;
  margin-left: 20px;
}

.ins-submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
}

.ins-close-button:hover {
  background-color: #545a5f;
}

.tabs {
  margin-left: 10px;
  margin-right: 10px;
}

.nav-link {
  color: black;
  background-color: #eeeeee;
}

.nav-link:hover {
  color: black;
  background-color: #dadada;
}

.nav-link.active {
  color: #007bff;
  background-color: #ffffff;
}
</style>